import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';

import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { ApiError, BaseTypeahead, BaseTypeaheadService, MessageService } from '../../../../core';
import { RepresentanteFilterModalComponent } from '../filter';
import { Representante } from '../representante';
import { isRepresentanteInativo, representanteAtivo } from '../situacao';
import { TypeaheadRepresentanteHttpService } from './typeahead-representante-http.service';

@Component({
    selector: 'sgt-typeahead-representante',
    templateUrl: './typeahead-representante.component.html',
    styleUrls: ['./typeahead-representante.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TypeaheadRepresentanteComponent), multi: true },
    ]
})
export class TypeaheadRepresentanteComponent implements OnInit, AfterViewInit, BaseTypeahead<Representante> {
    @Input() entity: Representante;
    @Output() ngModelChange = new EventEmitter<Representante>();

    /** Se deve exibir somente os representantes ativos */
    @Input() somenteAtivos = false;
    /** Situação padrão */
    @Input() situacao: number;
    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() ngControl: NgControl;
    @Input() autofocus = false;
    @Input() dropup = false;
    /** Onde anexar o dropdown (ex.: 'body' para escapar de containers com overflow) */
    @Input() container: string;
    @Input() typeaheadOptionsInScrollableView = 5; // Quantidade de itens visíveis no no scroll do typeahead
    @Input() withAddonLeft: boolean;
    @Output() typeaheadChange = new EventEmitter<Representante>();
    @Output() entitySelected = new EventEmitter<Representante>(); // Emite evento quando a entidade foi selecionada no typeahead
    @Output() clearEntity = new EventEmitter<any>();


    @ViewChild('inputTypeahead', {static: true}) inputTypeahead: ElementRef;
    typeaheadOptionsLimit = 1000; // Quantidade máxima de registros exibidos no typeahead
    typeaheadSelected: string;
    typeaheadToken: string;
    typeaheadDataSource: Observable<Representante[]>;
    typeaheadNoResults: boolean;

    currentRequest: Subscription;
    isLoading: boolean;

    @ViewChild('representanteFilterModal') representanteFilterModal: RepresentanteFilterModalComponent;

    propagateChange: any = () => {};

    constructor(private baseTypeaheadService: BaseTypeaheadService,
                private messageService: MessageService,
                private typeaheadRepresentanteHttpService: TypeaheadRepresentanteHttpService) { }

    ngOnInit() {
        this.createDataSource();
    }

    ngAfterViewInit() {
        if (this.autofocus) {
            jQuery(this.inputTypeahead.nativeElement).focus();
        }
    }

    /** Cria o data source do typeahead */
    createDataSource() {
        this.typeaheadDataSource = Observable.create((observer: any) => {
            if (this.currentRequest) {
                this.currentRequest.unsubscribe();
            }

            // Se informado para filtrar somente os representantes ativos
            if (this.somenteAtivos) {
                this.situacao = representanteAtivo.id;
            }

            this.currentRequest = this.typeaheadRepresentanteHttpService.search(this.typeaheadToken, this.situacao, this.typeaheadOptionsLimit)
                                        .subscribe(
                                            (entities: Representante[]) => observer.next(entities),
                                            (error: ApiError) => {
                                                this.messageService.error(error.message, 'Erro ao pesquisar os representantes. Tente novamente', error);
                                                observer.next([]);
                                            }
                                        );
        });
    }


    /** Ao digitar no input do typeahead */
    onKeyup(e: KeyboardEvent) {
        this.baseTypeaheadService.onKeyup(this, e);
    }

    /** Ao sair do input do typeahead */
    onBlur() {
        this.baseTypeaheadService.onBlur(this);
        if (!this.entity) {
            this.clearEntity.emit();
        }
    }


    /** Verifica se o typeahead possui resultados */
    onChangeTypeaheadNoResults(noResults: boolean) {
        this.typeaheadNoResults = noResults;
    }

    /** Ao selecionar o representante no typeahead */
    onSelectEntity(tm: TypeaheadMatch) {
        this.baseTypeaheadService.onSelectEntity(this, tm);
        this.entitySelected.emit(this.entity);
    }

    /** Ao selecionar o representante no modal de pesquisa */
    onSelectEntityModal(representante: Representante) {
        if (representante) {
            this.entity = representante;
        } else {
            this.entity = null;
        }

        this.propagateChange(this.entity);
        this.typeaheadChange.emit(this.entity);
        this.entitySelected.emit(this.entity);
        this.writeValue(this.entity);
        jQuery(this.inputTypeahead.nativeElement).focus();
    }

    /** Limpa o typeahead e o model */
    clear() {
        this.baseTypeaheadService.clear(this);
        this.clearEntity.emit();
    }

    /** Seta o foco no input */
    setFocus() {
        jQuery(this.inputTypeahead.nativeElement).focus();
    }

    /** Abre o modal de pesquisa */
    search() {
        this.representanteFilterModal.open();
    }

   /** Quando recebe um objeto representante de "fora" do component */
    writeValue(value: Representante) {
        if (value) {
            this.baseTypeaheadService.writeValue(this, value, value.pessoa.nome);
        } else {
            this.baseTypeaheadService.writeValue(this, null);
        }
    }

    /** Propaga as alterações */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    /** Verifica se a situação do representante é inativo */
    isInativo(situacao: number): boolean {
        return isRepresentanteInativo(situacao);
    }
}
